export default __webpack_public_path__ + "static/media/waiting-tablet.837067e2.webp";